var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"type":"rule","show":_vm.$bus.rule.show,"title":_vm.$bus.transify['COMMON_RULE']},scopedSlots:_vm._u([{key:"dialog-content",fn:function(){return [_c('div',{ref:"ruleContent",staticClass:"rule-content",domProps:{"innerHTML":_vm._s(_vm.$bus.rule.content)}})]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7752da0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rule/index.vue
// module id = null
// module chunks = 